import { AxiosRequestConfig } from 'axios';
import API from '../API';
import User from '../../models/User';

export const getLoginUrl = (
  queryParams: Record<string, unknown> = {},
  options: AxiosRequestConfig = {},
): Promise<any> => API.makeGetRequest('/login-info', queryParams, options) as Promise<any>;

export const getUserInfo = (
  queryParams: Record<string, unknown> = {},
  options: AxiosRequestConfig = {},
): Promise<User> => API.makeGetRequest('/users/current', queryParams, options) as Promise<User>;

export const getSessionTimeout = (
  queryParams: Record<string, unknown> = {},
  options: AxiosRequestConfig = {},
): Promise<any> => API.makeGetRequest('/users/timeout', queryParams, options) as Promise<any>;
